export default "__VITE_ASSET__CqRLjVws__"